import { render, staticRenderFns } from "./LanguageAndAllSelector.vue?vue&type=template&id=257251df&scoped=true&"
import script from "./LanguageAndAllSelector.vue?vue&type=script&lang=js&"
export * from "./LanguageAndAllSelector.vue?vue&type=script&lang=js&"
import style0 from "./LanguageAndAllSelector.vue?vue&type=style&index=0&id=257251df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257251df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemContent,VListItemIcon,VListItemTitle,VRow,VSelect})
